module.exports = __webpack_public_path__ + "media/members/merge-ff4f814d.svg";